import { PlaceholderPlugin, UploadErrorCode } from '@alpod-ai-writer/plate-plugins/media/react';
import { usePluginOption } from '@udecode/plate/react';
import { useEffect } from 'react';
import { toast } from 'sonner';

export const useUploadErrorToast = () => {
    const uploadError = usePluginOption(PlaceholderPlugin, 'error');
    useEffect(() => {
        if (!uploadError) return;
        const { code, data } = uploadError;
        console.log('Upload error', uploadError);
        switch (code) {
            case UploadErrorCode.INVALID_FILE_SIZE: {
                toast.error(
                    `Velikost souborů ${data.files
                        .map((f) => f.name)
                        .join(', ')} není v rámci povoleného rozsahu.`
                );
                break;
            }
            case UploadErrorCode.INVALID_FILE_TYPE: {
                toast.error(
                    `Typ souborů ${data.files
                        .map((f) => f.name)
                        .join(', ')} není povolen.`
                );
                break;
            }
            case UploadErrorCode.TOO_LARGE: {
                toast.error(
                    `Velikost souborů ${data.files
                        .map((f) => f.name)
                        .join(', ')} je větší, než povolená hranice ${data.maxFileSize}.`
                );
                break;
            }
            case UploadErrorCode.TOO_LESS_FILES: {
                toast.error(
                    `Minimální počet souborů je ${data.minFileCount} pro ${data.fileType}.`
                );
                break;
            }
            case UploadErrorCode.TOO_MANY_FILES: {
                toast.error(
                    `Maximální povolený počet souborů je ${data.maxFileCount} ${
                        data.fileType ? `pro ${data.fileType}` : ''
                    }.`
                );
                break;
            }
            default: {
                toast.error('Nastala neočekávaná chyba při nahrávání souboru.');
            }
        }
    }, [uploadError]);
};

export const MediaUploadToast = () => {
    useUploadErrorToast();
    return null;
};
